import * as yup from 'yup';
import { email, password, firstName, lastName } from './types';
export default yup.object().shape({
  firstName,
  lastName,
  email,
  password
});
